"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendInfoToWorkItem = void 0;
const react_1 = __importStar(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const AlternativeTitleCard_1 = __importDefault(require("@Components/Cards/WorkDetailCards/AlternativeTitleCard"));
const RecordingCard_1 = __importDefault(require("@Components/Cards/WorkDetailCards/RecordingCard"));
const WriterCardFull_1 = require("@Components/Cards/WorkDetailCards/WriterCards/WriterCardFull");
const OriginalPublisherCardFull_1 = __importDefault(require("@Components/Cards/WorkDetailCards/OriginalPublisherCards/OriginalPublisherCardFull"));
const AdminPublisherCardFull_1 = __importDefault(require("@Components/Cards/WorkDetailCards/AdminPublisherCards/AdminPublisherCardFull"));
const publishers_counter_1 = require("@App/helpers/publishers-counter");
const tooltip_text_1 = require("@Const/tooltip-text");
const Tag_1 = require("../Tag");
const recording_1 = require("@App/api/routes/recording");
const ExtendInfoToWorkItem = (props) => {
    const { writers, alternativeTitles, originalPublishers, matchedRecordings, holdTypeId, iswc, songCode } = props;
    const [completeMatchedRecordings, setCompleteMatchedRecordings] = (0, react_1.useState)();
    const allPublishersCount = (0, publishers_counter_1.publishersCounter)(originalPublishers);
    const holdIds = [21, 61, 62, 63, 64, 101, 102, 103, 104, 105, 106, 107];
    const onHold = holdTypeId ? holdIds.includes(holdTypeId) : false;
    (0, react_1.useEffect)(() => {
        (0, recording_1.getDspRecordingsForSongCode)(songCode !== null && songCode !== void 0 ? songCode : '', { limit: 10, page: 1 }).then((axiosResult) => {
            setCompleteMatchedRecordings(axiosResult.data.recordings);
        });
    }, []);
    return (react_1.default.createElement("div", { className: 'extend-info-work-item' },
        react_1.default.createElement("div", { className: "review-work-detail" },
            react_1.default.createElement("div", { className: "review-entity-head" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "entity-img" },
                        react_1.default.createElement("img", { src: common_1.ICONS.workDetails, alt: "work details" })),
                    react_1.default.createElement("h5", null, "Work Details"),
                    onHold && react_1.default.createElement(Tag_1.TagComponent, { type: 'dispute', name: 'On Hold: Has Rights in Dispute' }))),
            iswc ? (react_1.default.createElement("div", { className: "work-detail-info" },
                react_1.default.createElement("p", { className: 'small-2' },
                    react_1.default.createElement("span", null, "ISWC:\u00A0"),
                    react_1.default.createElement("strong", null, iswc)))) : null,
            react_1.default.createElement("div", { className: "review-cards" },
                react_1.default.createElement("p", { className: "small bold" }, "Alternative titles"),
                alternativeTitles.length
                    ? alternativeTitles.map((data, index) => (react_1.default.createElement("div", { className: "review-alternative-title-card", key: data.id ? data.id : index },
                        react_1.default.createElement(AlternativeTitleCard_1.default, { data: data }))))
                    : null)),
        react_1.default.createElement("div", { className: "review-writers" },
            react_1.default.createElement("div", { className: "review-entity-head" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "entity-img" },
                        react_1.default.createElement("img", { src: common_1.ICONS.writers, alt: "writers" })),
                    react_1.default.createElement("h5", null,
                        "Writers (",
                        writers.length,
                        ")"),
                    react_1.default.createElement("div", { className: "helper", title: tooltip_text_1.TOOLTIP_TEXT.extendInfoToWorkItem.writers },
                        react_1.default.createElement("img", { src: common_1.ICONS.help2, alt: "helper" })))),
            react_1.default.createElement("div", { className: "review-cards" }, writers.length
                ? writers.map((data, index) => (react_1.default.createElement("div", { className: "review-writers-card", key: data.id ? data.id : index },
                    react_1.default.createElement(WriterCardFull_1.WriterCardFull, { data: data }))))
                : null)),
        react_1.default.createElement("div", { className: "review-publishers" },
            react_1.default.createElement("div", { className: "review-entity-head" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "entity-img" },
                        react_1.default.createElement("img", { src: common_1.ICONS.publishers, alt: "publishers" })),
                    react_1.default.createElement("h5", null,
                        "Publishers (",
                        allPublishersCount,
                        ")"))),
            originalPublishers.length
                ? originalPublishers.map((op, index) => (react_1.default.createElement(react_1.default.Fragment, { key: op.id ? op.id : index },
                    react_1.default.createElement("div", { className: "review-cards" },
                        react_1.default.createElement("p", { className: "small bold" }, "Publisher"),
                        react_1.default.createElement("div", { className: "review-op-card" },
                            react_1.default.createElement(OriginalPublisherCardFull_1.default, { data: op }))),
                    op.administratorPublishers.length ? (react_1.default.createElement("div", { className: "review-cards" },
                        react_1.default.createElement("p", { className: "small bold" },
                            "Administrators (",
                            op.administratorPublishers.length,
                            ")"),
                        op.administratorPublishers.map((ap, apIndex) => (react_1.default.createElement("div", { className: "review-ap-card", key: ap.id ? ap.id : apIndex },
                            react_1.default.createElement(AdminPublisherCardFull_1.default, { data: ap })))))) : null)))
                : null),
        react_1.default.createElement("div", { className: "review-recordings" },
            react_1.default.createElement("div", { className: "review-entity-head" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "entity-img" },
                        react_1.default.createElement("img", { src: common_1.ICONS.recordings, alt: "recordings" })),
                    react_1.default.createElement("h5", null,
                        "Recordings (",
                        matchedRecordings.count,
                        ")"))),
            react_1.default.createElement("div", { className: "review-cards" }, completeMatchedRecordings === null || completeMatchedRecordings === void 0 ? void 0 : completeMatchedRecordings.map((data, index) => (react_1.default.createElement("div", { className: "review-recordings-card", key: data.id ? data.id : index },
                react_1.default.createElement(RecordingCard_1.default, { data: data }))))))));
};
exports.ExtendInfoToWorkItem = ExtendInfoToWorkItem;
